import React, { type MouseEvent, useState } from 'react'
import { Link } from 'react-router-dom'

import { type HomepageNavItem } from '../../types'
import styles from './styles.module.scss'

const isExternal = (url: string) => /^https?:\/\//i.test(url)

const HomeNavigation = ({ items }: { items: HomepageNavItem[] }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const scrollToContact = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    setIsMenuOpen(false)
  }

  return (
    <header className={styles.header}>
      <nav className={styles.nav} aria-label="Main navigation">
        <Link className={styles.logoLink} to="/" aria-label="Urus Advisory home">
          <img
            className={styles.logo}
            src={require('../../../../../public/images/logo.svg')}
            alt="Urus Advisory"
          />
        </Link>
        <button
          type="button"
          className={styles.menuButton}
          aria-expanded={isMenuOpen}
          aria-controls="homepage-navigation-links"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
          <span className={styles.visuallyHidden}>Toggle navigation</span>
        </button>
        <div
          id="homepage-navigation-links"
          className={`${styles.links} ${isMenuOpen ? styles.linksOpen : ''}`}
        >
          {items.map((item) =>
            item.url === '#contact' ? (
              <a key={item.label} href={item.url} onClick={scrollToContact}>
                {item.label}
              </a>
            ) : isExternal(item.url) ? (
              <a key={item.label} href={item.url} target="_blank" rel="noreferrer">
                {item.label}
              </a>
            ) : (
              <Link key={item.label} to={item.url} onClick={() => setIsMenuOpen(false)}>
                {item.label}
              </Link>
            )
          )}
        </div>
      </nav>
    </header>
  )
}

export default HomeNavigation
